import { render, staticRenderFns } from "./LeaveBigScreen.vue?vue&type=template&id=46655b2f"
import script from "./LeaveBigScreen.vue?vue&type=script&lang=js"
export * from "./LeaveBigScreen.vue?vue&type=script&lang=js"
import style0 from "./LeaveBigScreen.vue?vue&type=style&index=0&id=46655b2f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports